import { render, staticRenderFns } from "./subsidiary-ledger-types.vue?vue&type=template&id=32b8827c&"
import script from "./subsidiary-ledger-types.vue?vue&type=script&lang=js&"
export * from "./subsidiary-ledger-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports